export { default } from "./Skeleton.js";
export * from "./skeletonClasses.js";
export { default as skeletonClasses } from "./skeletonClasses.js";